<span>{{ typeValue | translate }}</span>